import {Button} from "@dp-instant/ui";
import {SVG} from "@game/ui/images";
import {IClickableComponentProps} from "@game/ui/interface/IClickableComponentProps";
import cn from "classnames";
import "./BackButton.less";
import {playUIClickSound} from "@game/helpers";
import {hapticMedium} from "@game/haptic";

export const BackButton = (props: IClickableComponentProps) => (
    <Button
        className={cn("back-button", props.className)}
        onClick={() => {
            if (props.onClick) {
                playUIClickSound();
                hapticMedium();
                props.onClick();
            }
        }}
    >
        <SVG.BackButton />
    </Button>
);
